export const COLLAPSE_ID = 'BOARD_COLLAPSE_ID'

export const collapseId = id => ({ type: COLLAPSE_ID, id })
